import React from "react";
import "./FastGamesStyle.scss";
import { fastGamesTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import GameCard from "../Common_UI_Kit/GameCard";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const FastGamesSection = ({ sectionHeadingText }) => {
  const { fastGamesContent } = fastGamesTextContent;

  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/fast-games-list");
  };

  const handleCardClick = () => {
    navigate(`/fast-game-play`);
  };

  return (
    <section className="slot-games-section">
      <div className="slot-games-wrap">
        <SectionHeading>{sectionHeadingText || fastGamesTextContent.headingText}</SectionHeading>

        <div className="slot-games-box">
          <p className="para-text">{fastGamesTextContent.paraText}</p>

          <div className="games-grid-box">
            {fastGamesContent.map((game, index) => (
              <GameCard
                key={index}
                gameImageSrc={game.gameImageSrc}
                gameNameText={game.gameNameText}
                onClick={() => handleCardClick(index)}
              />
            ))}
          </div>

          <div className="btn-box">
            <CustomButton buttonType="secondary" label={fastGamesTextContent.btnText} onClick={handleButtonClick} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FastGamesSection;
